import React, { ChangeEventHandler, useCallback, useContext, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { SKEventArtifact } from "../../../../../models/SKArtifact";
import { Location } from "./AddLocatioinSeacrh";
// import config from "../../../../../firebase/config/config.json";
import { loadConfig } from "../../../../../firebase/config";
import { add } from "date-fns";

declare global {
  interface Window {
    google: any;
  }
}

interface AddPlaceFieldProps {
  name: string;
  title: string;
  note: string;
  placeholder: string;
  index: number;
  isVisible: boolean;
  value: string;
  onChange: (address: string, location: Location, link: string, title: string) => void;
  disabled?: boolean;
}

export const AddPlaceField = ({ name, title, note, placeholder, index, isVisible, value, onChange, disabled = false }: AddPlaceFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const [inputValue, setInputValue] = useState(value);
  // const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const [error, setError] = useState<string>("");

  const schema = Yup.object().shape({
    title: Yup.string().required(`Title is required!`).max(100),
  });

  const apiKey = loadConfig().apiKey;

  useEffect(() => {
    const loadScript = () => {
      if (!window.google && apiKey) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${"AIzaSyC6UUCKQF8KLmoOxKg6jdGG5JQSKrB-0fY"}&libraries=places`;
        script.async = true;
        script.onload = () => {
          initializeAutocomplete();
        };
        script.onerror = () => setError("Failed to load Google Maps API script.");
        document.body.appendChild(script);
      } else {
        initializeAutocomplete();
      }
    };

    loadScript();

    return () => {
      if (autocompleteRef.current) {
        google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [apiKey]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // const initializeAutocomplete = () => {
  //   if (inputRef.current && window.google) {
  //     const autocompleteInstance = new google.maps.places.Autocomplete(inputRef.current);
  //     autocompleteInstance.addListener("place_changed", handlePlaceChanged);
  //     setAutocomplete(autocompleteInstance);
  //     console.log("Autocomplete initialized");
  //   } else {
  //     console.log("Input ref is null or Google Maps is not loaded");
  //   }
  // };
  const initializeAutocomplete = () => {
    if (inputRef.current && window.google) {
      const autocompleteInstance = new google.maps.places.Autocomplete(inputRef.current);
      autocompleteInstance.addListener("place_changed", handlePlaceChanged);
      autocompleteRef.current = autocompleteInstance;
      console.log("Autocomplete initialized");
    } else {
      console.log("Input ref is null or Google Maps is not loaded");
    }
  };

  // const handlePlaceChanged = useCallback(async () => {
  //   if (autocomplete) {
  //     const place = await autocomplete.getPlace();
  //     if (place.geometry && place.geometry?.location) {
  //       console.log("Selected place:", place);
  //       const formattedAddress = place.formatted_address || "";
  //       const lat = await place.geometry.location.lat();
  //       const lng = await place.geometry.location.lng();
  //       const location: Location = { lat, lng };
  //       console.log(`Selected address: ${formattedAddress}`);
  //       setInputValue(formattedAddress);
  //       onChange(formattedAddress, location, `https://www.google.com/maps/place/?q=place_id:${place.place_id}`);
  //     } else {
  //       console.log("Place does not have geometry: " + place);
  //     }
  //   } else {
  //     setInputValue(inputRef.current?.value ?? "");
  //     onChange(inputRef.current?.value ?? "", { lat: 0, lng: 0 }, "");
  //     console.log("Autocomplete instance is null");
  //   }
  // }, [autocomplete, onChange, inputRef]);
  const handlePlaceChanged = useCallback(async () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry && place.geometry.location) {
        console.log("Selected place:", place);
        const formattedAddress = place.formatted_address || "";
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const location: Location = { lat, lng };
        // setInputValue(formattedAddress);
        const website = place.website ?? "";
        onChange(formattedAddress, location, website, inputRef.current?.value ?? "");
      } else {
        console.log("Place does not have geometry: ", place);
      }
    } else {
      console.warn("Autocomplete instance is null");
      const fallbackAddress = inputRef.current?.value ?? "";
      setInputValue(fallbackAddress);
      onChange(fallbackAddress, { lat: 0, lng: 0 }, "", "");
    }
  }, [onChange, inputRef]);

  return (
    <>
      <div className="relative w-full min-w-[200px] max-w-[486px]">
        {isVisible ? (
          <div className="flex items-center">
            <span>{index && <span className="content_count">{index}</span>}</span>
            {title && <span className="content_title">{title}</span>}
          </div>
        ) : null}
        {note && <div className="notes-class-content">{note}</div>}
        <div className="flex input-class">
          <input
            type="text"
            name={name}
            id={name}
            className="input-text"
            placeholder={placeholder}
            required
            ref={inputRef}
            value={inputValue}
            onChange={async e => {
              // if (autocomplete) {
              //   const place = autocomplete.getPlace();
              //   if (place && place.geometry && place.geometry?.location) {
              //     const lat = await place.geometry.location.lat();
              //     const lng = await place.geometry.location.lng();
              //     onChange(e.target.value, { lat, lng }, `https://www.google.com/maps/place/?q=place_id:${place.place_id}`);
              //   } else {
              //     onChange(e.target.value, { lat: 0, lng: 0 }, "");
              //   }
              // } else {
              //   onChange(e.target.value, { lat: 0, lng: 0 }, "");
              // }

              setInputValue(e.target.value);
            }}
            disabled={disabled}
          />
        </div>

        {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
      </div>
    </>
  );
};
